import { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { cn } from '@/lib/utils';

interface PasswordInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
  label?: string;
}

export const PasswordInput = ({ className, error, label, ...props }: PasswordInputProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label className={cn(
          "text-xs text-white",
          !isFocused && !props.value && "hidden"
        )}>
          {label}
        </label>
      )}
      <div className="relative">
        <div className={cn(
          "relative flex items-center w-full rounded-md border border-white bg-white/5",
          error && "border-red-500",
          className
        )}>
          <input
            type={showPassword ? "text" : "password"}
            className="flex h-12 w-full rounded-md border-0 bg-transparent px-3 py-2 text-sm text-white placeholder:text-white/60 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50 comment-selection"
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            placeholder={label}
            {...props}
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="flex items-center justify-center px-3 text-white/60 hover:text-white"
          >
            {showPassword ? <Eye className="w-5 h-5" /> : <EyeOff className="w-5 h-5" />}
          </button>
        </div>
      </div>
    </div>
  );
}; 